export default __webpack_public_path__ + "static/media/2400.1eb23e29.png";